import React, { useState, useEffect, useMemo } from "react";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';

export const Telcos = ({ settings }) => {
  const { 
    title, 
    description 
  } = settings.settings.section || {};

  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  useEffect(() => {
    // Add a small delay before showing the animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  // Extract telco data from metaobjects
  const telcoData = settings.settings.telcoData || [];

  // Get unique categories from telco data
  const categories = useMemo(() => {
    const uniqueCategories = [...new Set(telcoData.map(telco => telco.category).filter(Boolean))];
    return ['all', ...uniqueCategories];
  }, [telcoData]);

  // Filter telco data based on selected category
  const filteredTelcoData = useMemo(() => {
    if (selectedCategory === 'all') {
      return telcoData;
    }
    return telcoData.filter(telco => telco.category === selectedCategory);
  }, [telcoData, selectedCategory]);

  return (
    <section>
      <div className="flex flex-col gap-12 md:gap-16">
        <div className="w-full overflow-x-auto max-lg:pb-1">
          <div className="flex justify-center items-center gap-8 min-w-max mx-auto">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`button-tertiary shrink-0 px-6 py-3 b_a1 tracking-wider cursor-pointer border rounded-[5px] ${
                  selectedCategory === category ? 'active underline' : ''
                }`}
              >
                {category === 'all' ? 'View All' : category}
              </button>
            ))}
          </div>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-8 lg:gap-y-16 lg:gap-x-8`}>
          {filteredTelcoData.map((telco, index) => (
            <a href={`/pages/telcos/${telco.handle}`} className={'flex relative h-[454px] md:h-[605.93px]'}>
              <div className="w-full h-full overflow-hidden rounded-[4px] relative">
                {telco.image &&
                  <img 
                    src={telco.image} 
                    alt={telco.title} 
                    className="w-full h-full object-cover pointer-events-none"
                  />
                }
                {/* Dark overlay */}
                <div className="absolute bottom-0 w-full h-80" 
                  style={{
                    background: 'linear-gradient(180deg, rgba(30, 30, 30, 0) 0%, #1E1E1E 100%)'
                  }}
                ></div>
                <div className="absolute inset-0 flex flex-col z-[10] text-white pointer-events-none p-4 md:p-5 gap-4 md:gap-[22px]">
                  <div className={`flex flex-col justify-end items-start h-full gap-2 md:gap-2.5`}>
                    <h6 className={`${isMobile ? 'b_regular_normal' : 'b_large_normal'} !font-normal`}>{telco.title}</h6>
                    {telco.description && (
                      <Paragraph classes={`${isMobile ? 'b_tiny_normal' : 'b_regular_light'}`} text={telco.description} maxChars={0}/>
                    )}
                  </div>
                  <div className="inline-flex justify-center items-center gap-2">
                    <div className={`flex-1 ${isMobile ? 'b_a2' : 'b_a1'}`}>Read More</div>
                    <div className="w-3 h-2.5 lg:w-[17px] lg:h-3.5">
                      <svg xmlns="http://www.w3.org/2000/svg" width="auto" height="auto" viewBox="0 0 19 17" fill="none">
                        <path d="M11.2703 0.667236L18.0178 8.00785M18.0178 8.00785L11.2703 15.3485M18.0178 8.00785L0.667236 8.00785" stroke="white" stroke-width="1.33466" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Telcos;